import { DonationFormCategory } from "../../enums/common";
import { TicketingFormCategory } from "../../enums/ticketing";
export const ORGANIZATION_ASSISTANT_DESTINATIONS = [
    "payouts",
    "payout_detail",
    "bank",
    "bank_settings",
    "create_bank_account",
    "stripe_onboarding",
    "identity_verification",
    "payments",
    "payment",
    "form_editor",
    "campaign_hub",
    "campaigns",
    "team",
    "invite_member",
    "tax_receipts",
    "organization_settings",
    "organization_information",
    "organization_page_editor",
    "communications",
    "contacts",
    "insights",
];
export const ORGANIZATION_ASSISTANT_HANDOFF_TOPICS = [
    "payout_failed",
    "payout_delayed",
    "payout_schedule",
    "verification",
    "refund",
    "dispute",
    "bank_account",
    "account_recovery",
    "two_factor",
    "other",
];
export const ORGANIZATION_ASSISTANT_HANDOFF_TOPIC_LABELS = {
    payout_failed: "Failed payout",
    payout_delayed: "Delayed payout",
    payout_schedule: "Payout schedule",
    verification: "Verification",
    refund: "Refund",
    dispute: "Dispute",
    bank_account: "Bank account",
    account_recovery: "Account recovery",
    two_factor: "Two-factor authentication",
    other: "Other",
};
export const ORGANIZATION_ASSISTANT_PAGE_PATH = /^\/o(\/[a-z0-9-]+)*$/;
export const ORGANIZATION_ASSISTANT_PAGE_PATH_MAX_LENGTH = 512;
export const ORGANIZATION_ASSISTANT_PAGE_PAYOUT_ID = /^po_[A-Za-z0-9]{1,64}$/;
export const ORGANIZATION_ASSISTANT_CAMPAIGN_TYPES = [
    DonationFormCategory.DonationForm,
    DonationFormCategory.PeerToPeerCampaign,
    TicketingFormCategory.Event,
    TicketingFormCategory.Lottery,
    TicketingFormCategory.Auction,
    TicketingFormCategory.MembershipV2,
    TicketingFormCategory.Shop,
    "signUpForms",
];
